import "./Message.scss";

function Message({ message }) {
  return <div className="message">{message}</div>;
}

export default Message;
